/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ResponsePersonDTO { 
    bornCityId?: number;
    bornCityName?: string;
    bornDate: string;
    firstname: string;
    id?: number;
    lastname: string;
    sex: ResponsePersonDTO.SexEnum;
}
export namespace ResponsePersonDTO {
    export type SexEnum = 'MALE' | 'FEMALE';
    export const SexEnum = {
        MALE: 'MALE' as SexEnum,
        FEMALE: 'FEMALE' as SexEnum
    };
}